const VISITOR_COOKIE = 'visitor_id';
// 2 years — the visitor id is a long-lived, stable anonymous identifier.
const VISITOR_MAX_AGE_SEC = 2 * 365 * 24 * 60 * 60;

function readVisitorCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${VISITOR_COOKIE}=([^;]+)`));
  return match?.[1] ? decodeURIComponent(match[1]) : undefined;
}

/** Read the persistent visitor id without creating one (use after login for merge). */
export function getVisitorId(): string | undefined {
  return readVisitorCookie();
}

/**
 * Return the persistent anonymous visitor id, creating and persisting a fresh one
 * (2-year cookie) on first call. Idempotent — safe to call on every session start.
 * Returns undefined only outside the browser or when secure-context crypto is missing.
 */
export function ensureVisitorId(): string | undefined {
  const existing = readVisitorCookie();
  if (existing) return existing;
  if (typeof document === 'undefined') return undefined;
  if (typeof crypto === 'undefined' || typeof crypto.randomUUID !== 'function') return undefined;

  const id = crypto.randomUUID();
  try {
    const isSecure = typeof location !== 'undefined' && location.protocol === 'https:';
    // Not HttpOnly — the frontend must read it to attach `visitorId` to tracking calls.
    document.cookie = `${VISITOR_COOKIE}=${id}; Path=/; Max-Age=${VISITOR_MAX_AGE_SEC}; SameSite=Lax${isSecure ? '; Secure' : ''}`;
  } catch {
    return undefined;
  }
  return id;
}
